export const DELIMETER_NAMESPACE = ':'
export const DELIMETER_NAMESPACE_ALT = '___'
export const KEY_P_FORMATTEXT = 'P'
export const KEY_P_FORMATTEXT_2 = 'ted___P'

// el_attrs
// el_nest_text
